import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "./staffdashboard.css";
import PharmMedicine from "../AddMedicines/PharmMedicine";
import LaboratoryTestPricing from "../AddLabTest/LaboratoryTestPricing.js";
import PharmMedHome from "../AddMedicines/PharmMedHome.js";

function DataManagement() {
  const [selected, setSelected] = useState('medicines')
  const navigate = useNavigate()
  const handleDefault = () => {
    setSelected('medicines')
  }

  return (
    <>
      <div
        className="row service-providers-wrapper service-providers-wrapper--data"
        style={{ minHeight: "71vh", paddingTop: "1%", width: "100%" }}
      >
        <div className="col-3 service-sidecard-wrapper service-sidecard-wrapper--data">
          <div className="service-sidecard service-sidecard--compact">
            <div className="service-sidecard-header">
              <div className="service-sidecard-icon">D</div>
              <div>
                <p className="service-sidecard-title">Data management</p>
                <p className="service-sidecard-subtitle">Configure care resources</p>
              </div>
            </div>
            <div className="service-sidecard-menu">
              <button
                className={
                  selected === "medicines"
                    ? "patientRecbutton1 service-sidecard-btn active"
                    : "patientRecbutton service-sidecard-btn"
                }
                onClick={() => {
                  setSelected("medicines");
                }}
              >
                Medicines
              </button>
              <button
                className={
                  selected === "laboratory"
                    ? "patientRecbutton1 service-sidecard-btn active"
                    : "patientRecbutton service-sidecard-btn"
                }
                onClick={() => {
                  setSelected("laboratory");
                  navigate("/lab-management");
                }}
              >
                Laboratory
              </button>
              <button
                className={
                  selected === "scan"
                    ? "patientRecbutton1 service-sidecard-btn active"
                    : "patientRecbutton service-sidecard-btn"
                }
                onClick={() => {
                  setSelected("scan");
                }}
              >
                Scan
              </button>
              <button className="patientRecbutton service-sidecard-btn">Procedures</button>
              <button className="patientRecbutton service-sidecard-btn">Observations</button>
              <button className="patientRecbutton service-sidecard-btn">Symptoms</button>
              <button className="patientRecbutton service-sidecard-btn">Allergy</button>
              <button className="patientRecbutton service-sidecard-btn">Primary Disease</button>
              <button className="patientRecbutton service-sidecard-btn">Comorbidities</button>
            </div>
          </div>
        </div>
        <div className="col-9 service-content-card service-content-card--data">
          {selected === "medicines" ? <PharmMedHome /> : ""}
        </div>
      </div>
    </>
  );
}
export default DataManagement;
